// blog33.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "../allcss/blog18.css";
import blogImage from "../Asets/Blog.jpg";
import detailImg from "../Asets/blog3838.png";
import Header from "../components/header";
import Footer from "../components/footer";

const Blog33 = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="blog-section">
        {/* Hero Section */}
        <div
          className="blog-hero"
          style={{ backgroundImage: `url(${blogImage})` }}
        >
          <div className="blog-overlay">
            <h1 className="blog-title">Our Blog</h1>
            <p className="breadcrumb">
              <span
                style={{ cursor: "pointer", color: "#fff" }}
                onClick={() => navigate("/")}
              >
                Home
              </span>
              <span>
                {" "}
                / Our Blog / Why Nutrition Matters in Early Childhood Development
              </span>
            </p>
          </div>
        </div>

        {/* Blog Detail */}
        <div className="blog-container">
          <h2 className="section-title">
            Why Nutrition Matters in Early Childhood Development | Red School House
          </h2>

          <br />
          <div className="published-badge">
            Published on: 15 December 2025
          </div>
          <br />

          <img
            src={detailImg}
            alt="Why Nutrition Matters in Early Childhood Development"
            className="blog-detail-img"
          />

          <div className="blog-detail-content">
            <p>
              Early childhood is a crucial stage of growth where the foundation
              for lifelong health, learning, and behavior is formed. At{" "}
              <strong>Red School House</strong>, recognized as the best play
              school in Harni, Vadodara, we believe that nutrition plays a vital
              role in a child’s overall development alongside learning and play.
            </p>

            <hr />

            <h3>🥗 The Importance of Nutrition in Early Childhood</h3>
            <p>Proper nutrition during the early years supports:</p>
            <ul>
              <li>Healthy brain development</li>
              <li>Strong immunity</li>
              <li>Physical growth and daily energy</li>
              <li>Emotional well-being and focus</li>
              <li>Better learning outcomes</li>
            </ul>
            <p>
              Children who receive balanced nutrition are more attentive,
              active, and confident in their learning environment.
            </p>

            <hr />

            <h3>📚 How Nutrition Impacts Learning at Play School</h3>
            <p>
              At a quality play school in Harni Vadodara, nutrition and education
              go hand in hand. Well-nourished children:
            </p>
            <ul>
              <li>Develop better concentration skills</li>
              <li>Show improved memory and cognitive abilities</li>
              <li>Participate more actively in creative and physical activities</li>
              <li>Build strong social and emotional skills</li>
            </ul>
            <p>
              At Red School House, we understand that learning doesn’t happen
              only through books — it starts with healthy daily habits.
            </p>

            <hr />

            <h3>🌱 Our Approach to Holistic Child Development</h3>
            <p>
              As a trusted play school in Harni, Red School House focuses on:
            </p>
            <ul>
              <li>Age-appropriate activities</li>
              <li>Creative play and exploration</li>
              <li>Emotional and social development</li>
              <li>Awareness of healthy eating habits</li>
              <li>A safe, nurturing, and secure environment</li>
            </ul>
            <p>
              Every child is treated as unique, ensuring their first learning
              experience is joyful and meaningful.
            </p>

            <hr />

            <h3>🏫 Why Choose Red School House – Play School in Harni Vadodara</h3>
            <p>Parents choose Red School House Vadodara because we offer:</p>
            <ul>
              <li>A caring and child-friendly atmosphere</li>
              <li>Strong focus on holistic development</li>
              <li>Experienced and dedicated educators</li>
              <li>Emphasis on early learning, creativity, and well-being</li>
              <li>Convenient location in Harni</li>
            </ul>
            <p>
              Our goal is to support children in unlocking their full potential
              while building a strong foundation for future learning.
            </p>

            <hr />

            <h3>📍 Location &amp; Contact Details</h3>
            <p>
              <strong>Address:</strong> A-25, Castle White, Opposite Main Harni
              Water Tank, Harni Sama Link Road, Vadodara – 390008
              <br />
              <strong>Mobile:</strong>{" "}
              <a href="tel:+917778851070">+91 77788 51070</a>
              <br />
              <strong>Email:</strong>{" "}
              <a href="mailto:redschoolhousebaroda2025@gmail.com">
                redschoolhousebaroda2025@gmail.com
              </a>
              <br />
              <strong>Website:</strong>{" "}
              <a
                href="https://www.redhouseschoolvadodara.in/"
                target="_blank"
                rel="noreferrer"
              >
                https://www.redhouseschoolvadodara.in/
              </a>
              <br />
              <strong>Instagram:</strong>{" "}
              <a
                href="https://www.instagram.com/redschoolhousebaroda/"
                target="_blank"
                rel="noreferrer"
              >
                https://www.instagram.com/redschoolhousebaroda/
              </a>
            </p>

            <p className="blog-tags">
              #NutritionForKids &nbsp;
              #EarlyChildhoodDevelopment &nbsp;
              #PlaySchoolInHarni &nbsp;
              #RedHouseSchoolVadodara &nbsp;
              #HealthyLearning &nbsp;
              #HolisticDevelopment
            </p>

            {/* Back Button */}
            <div className="back-to-blogs-btn-wrapper">
              <button
                className="back-to-blogs-btn"
                onClick={() => navigate("/blog")}
              >
                Go Back To Blogs
              </button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Blog33;
